module.exports = __webpack_public_path__ + "img/win_item7.05a53b8a.png";